export default __webpack_public_path__ + "static/media/SharpGrotesk.0841ef69.woff2";